import { createApiRef } from '@backstage/core-plugin-api';
import {
  ApplianceCapabilitiesResponse,
  ApplianceInfoResponse,
  ApplianceStateResponse,
  CommandResponse,
  ConfigResponse,
  ConnectivityEventsResponse,
  HistoryMapsResponse,
  PropertiesResponse,
  SearchAppliancesIdentityInfoByIdPartsResponse,
  SerializationResponse,
  TelemetryResponse,
  UsersResponse,
  WhitelistedPropertiesResponse,
} from './types';

/** @public */
export const OcpAppliancePageApiRef = createApiRef<OcpAppliancePageApi>({
  id: 'plugin.ocp-appliance-page.service',
});

/** @public */
export interface OcpAppliancePageApi {
  get(path: string): Promise<any>;
  getApplianceState(applianceId: string): Promise<ApplianceStateResponse>;
  getApplianceCapabilities(
    applianceId: string,
  ): Promise<ApplianceCapabilitiesResponse>;
  getApplianceCapabilitiesForceRefresh(
    applianceId: string,
  ): Promise<ApplianceCapabilitiesResponse>;
  getApplianceCommands(
    applianceId: string,
    limit: number,
  ): Promise<CommandResponse>;
  getWhitelistedProperties(
    applianceType: string,
  ): Promise<WhitelistedPropertiesResponse>;
  searchAppliancesIdentityInfoByIdParts(
    pnc: string,
    elc: string,
    sn: string,
    mac: string,
  ): Promise<SearchAppliancesIdentityInfoByIdPartsResponse>;
  getUsers(applianceId: string): Promise<UsersResponse>;
  getConfig(applianceId: string): Promise<ConfigResponse>;
  getConnectivityEvents(
    applianceId: string,
    limit: number,
  ): Promise<ConnectivityEventsResponse>;
  getTelemetryProperties(applianceType: string): Promise<PropertiesResponse>;
  getTelemetryEvents(
    applianceId: string,
    property: string,
    view: string,
    fromTimestamp: number,
    toTimestamp: number,
    includeCount: boolean,
  ): Promise<TelemetryResponse>;
  getSerializationStatus(applianceId: string): Promise<SerializationResponse>;
  getApplianceInfo(applianceId: string): Promise<ApplianceInfoResponse>;
  getHistoryMaps(applianceId: string): Promise<HistoryMapsResponse>;
}
